/**
 * @require ../pdf-designer.window.js
 */
(function (global) {
    if (!global.Model) {
        global.Model = {};
    }

    /**
     * @typedef ComponentOptions
     * @property {string} OID
     * @property {boolean} [IsTemplate]
     * @property {string} [Placeholder]
     * @property {string[]} [DisabledInModificationArea]
     * @property {string[]} [Fonts]
     * @property {boolean} [IsSubsampleCheckpoint]
     * @property {boolean} [IsTableCell]
     */

    /**
     * @typedef ComponentOptions
     */
    global.Model.ComponentOptions = (function () {
        /**
         * @param {ComponentOptions} settings
         * @constructor
         */
        function ComponentOptions(settings) {
            /**
             * @type {string}
             */
            this.OID = settings.OID;

            /**
             * @type {boolean}
             */
            this.IsTemplate = !!settings.IsTemplate;

            /**
             * @type {string|null}
             */
            this.Placeholder = this.IsTemplate ? settings.Placeholder : null;

            /**
             * @type {string[]}
             */
            this.DisabledInModificationArea = settings.DisabledInModificationArea || [];

            /**
             * @type {string[]}
             */
            this.Fonts = settings.Fonts || [];

            /**
             * @type {boolean}
             */
            this.IsSubsampleCheckpoint = !!settings.IsSubsampleCheckpoint;

            /**
             * @type {boolean}
             */
            this.IsTableCell = !!settings.IsTableCell;
        }

        ComponentOptions.prototype.constructor = ComponentOptions;

        return ComponentOptions;
    })();
})(Modifications.Popups.PdfDesigner || (Modifications.Popups.PdfDesigner = {}));